<script>
export default {
    props: {
        label: {
            type: String,
            default: 'Font',
        },
        fonts: {
            type: Array,
            required: true,
        },
        text: {
            type: String,
            default: 'Aa',
        },
        selectedFont: {
            type: Number,
            default: null,
        },
    },
    data() {
        return {
            displaySelect: false,
        };
    },
    computed: {
        selectedFontName() {
            return this.fonts.find((font) => font.id === this.selectedFont)?.name;
        },
    },
    methods: {
        toggleSelect() {
            this.displaySelect = !this.displaySelect;
        },
    },
};
</script>

<template>
    <div>
        <div class="label mb-2 mt-4">
            {{ label ?? 'Font' }}
        </div>

        <div class="relative">
            <button
                class="flex items-center justify-between px-4 py-2 w-full bg-2025-light-beige rounded"
                @click="toggleSelect"
            >
                <span
                    v-if="selectedFont"
                    :style="{ fontFamily: selectedFontName }"
                >
                    {{ selectedFontName }}
                </span>
                <span v-else>
                    Select a font
                </span>

                <svg
                    class="w-4 h-4 ml-2"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="2"
                        d="M19 9l-7 7-7-7"
                    />
                </svg>
            </button>
            <div
                v-if="displaySelect"
                class="absolute top-12 left-0 right-0 bg-white shadow-lg rounded w-full z-50"
            >
                <div
                    v-for="(font, index) in fonts"
                    :key="index"
                >
                    <button
                        class="rounded px-4 py-2 transition-shadow overflow-hidden text-lg w-full"
                        :class="selectedFont === font.id ? 'ring-primary ring-2' : 'ring-0 hover:ring-grey-light hover:ring-2'"
                        :style="{ fontFamily: font.name }"
                        @click="$emit('select', font); displaySelect = false;"
                    >
                        {{ font.name }}
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<style scoped lang="scss">

</style>
